/**
 * Returns a filtered data set containing all of the Objects that contain a property whose value matches
 * a given value.
 *
 * @public
 * @param  {Array} data Array of objects
 * @param  {*} findBy
 * @param  {Object} options
 * @return {Array} An array containing the Objects that contain a property whose value matches the `findBy`
 *  argument. The original Array is not modified.
 */
export default (function (data, findBy) {
  let {
    caseSensitive = false,
    fullTextMatch = true
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  findBy = typeof findBy === "string" ? findBy.trim() : findBy;

  if (!caseSensitive) {
    findBy = findBy.toString().toLowerCase();
  }
  /**
   * Checks for property value matching exactly with a given value.
   */


  if (fullTextMatch) {
    return data.filter(item => Object.keys(item).map(key => !caseSensitive && item[key] ? item[key].toString().toLowerCase() : item[key]).includes(findBy));
  } else {
    /**
     * Checks for property value matching partly with a given value.
     */
    return data.filter(item => Object.keys(item).map(key => !caseSensitive && item[key] ? item[key].toString().toLowerCase() : item[key]).some(elem => elem && elem.toString().indexOf(findBy) !== -1));
  }
});